import { Standard } from '@getvim/vim-connect';

export const specialty: Standard.Entities.Specialty = {
  description: '',
  taxonomies: [''],
};
